import { useState } from "react";
import AuthLayout from "../../../components/layouts/auth";
import TablePagination from "../../../components/table/table-pagination";
import { numberWithCommas } from "../../../lib/helper-support";
import TableSkeleton from "../../../components/loader/table-placeholder-loader";
import { Link } from "react-router-dom";
import moment from "moment";
import { useLoan } from "../../../composables/loan/useLoan";
import { LoanProps } from "../../../types/LoanProps";
import LoanStatusBadge from "../../../components/ui/loan-status-badge";
import { useDebounced } from "../../../hooks/useDebounce";
import SearchInput from "../../../components/form/search-input";

const Loan = () => {
  const [page, setCurrentPage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");

  const searchDebounced = useDebounced({
    value: search,
  });

  const { data, isLoading } = useLoan({
    page,
    search: searchDebounced,
  });

  return (
    <AuthLayout>
      <div className="items-center space-y-5 lg:justify-between lg:flex md:flex md:space-y-0">
        <div className="flex items-center gap-2 md:gap-6 flex-wrap">
          <h1 className="page-title">Loans</h1>
          <span className="text-tertiary font-[600] text-[14px]">
            {numberWithCommas(data?.total ?? 0)} loans
          </span>
        </div>
      </div>

      <div className="relative">
        <div>
            <SearchInput placeholder="Find user" value={search} onChangeInput={(e) => setSearch(e.target.value)} />
        </div>
        {/* table */}
        <div className="relative overflow-x-auto">
          <table className="mt-10 text-tertiary font-[600] text-[14px] w-full relative z-10 whitespace-nowrap">
            <thead>
              <tr className="border-b border-[#E6EAF0]">
                <td className="px-2 py-3">
                  {/* <input type='checkbox' /> */}#
                </td>
                <td className="px-6 py-3">Referernce</td>
                <td className="px-6 py-3">Status</td>
                <td className="px-6 py-3">User</td>
                <td className="px-6 py-3">Email</td>
                <td className="px-6 py-3">Amount</td>
                <td className="px-6 py-3">Repayment Date</td>
                <td className="px-6 py-3">Created At</td>
              </tr>
            </thead>
            <tbody className="relative">
              {isLoading && <TableSkeleton numberOfColumns={8} />}
              {!isLoading &&
                data?.items?.map((item: LoanProps, index: number) => (
                  <tr
                    key={index}
                    className="border-b border-[#E6EAF0] relative"
                    // style={{ backgroundColor: selectedUserAccounts.includes(user.cTag) ? '#E6EAF0' : '' }}
                  >
                    <td className="px-2 py-3">
                      {index + 1}
                      <Link
                        to={`/loans/${item.reference}`}
                        className="absolute top-0 bottom-0 left-0 w-full h-full hover:bg-[#E6EAF0] opacity-[0.2]"
                      />
                    </td>
                    <td className="px-6 py-3">{item.reference}</td>
                    <td className="px-6 py-3">
                      <LoanStatusBadge status={item.status} />
                    </td>
                    <td className="px-6 py-3">
                      {item.user.first_name} {item.user.last_name}
                    </td>
                    <td className="px-6 py-3">{item.user.email}</td>
                    <td className="px-6 py-3">
                      {numberWithCommas(item.amount)}
                    </td>
                    <td className="px-6 py-3">
                      {moment(item.repayment_date).format("MMM D, YYYY")}
                    </td>
                    <td className="px-6 py-3">
                      {moment(item.created_at).format("MMM D, YYYY")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        {/*--/ table */}
        {/* pagination */}
        {!isLoading && (
          <div className="mt-5">
            <TablePagination
              totalPages={data?.totalPages ?? 0}
              onPageChange={(page) => setCurrentPage(page)}
              currentPage={data?.page}
            />
          </div>
        )}
        {/* --/ pagination */}
      </div>
    </AuthLayout>
  );
};

export default Loan;
